<div class="ticket-block content-block">
    <div class="logo-container">
        <img class="logo" alt="{{ 'logo' | translate }}" [src]="customer?.logo" />
    </div>
    <h1 translate>Expired link</h1>
    <p translate>This link has expired.</p>
    <p>{{ 'If you want a new link, please contact your administrator' | translate }}.</p>
</div>
